import { Box } from "@mui/material";
import isSameDay from "date-fns/isSameDay";
import React from "react";

import {
  WorkerShiftCard
} from "./worker-shift-card";

export const WorkerDayColumn = ({ reassignment, date }: any) => {
  return (
    <Box sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minWidth: "161px",
      width: "100%",
      height: "116px",
      padding: 1,
    }}>
      {reassignment && isSameDay(new Date(reassignment.startDate), date) && (
        <WorkerShiftCard reassignment={reassignment} />
      )}
    </Box>
  )
}